import { render, staticRenderFns } from "./PhilaHeader.vue?vue&type=template&id=9af7d3e4"
import script from "./PhilaHeader.vue?vue&type=script&lang=js"
export * from "./PhilaHeader.vue?vue&type=script&lang=js"
import style0 from "./PhilaHeader.vue?vue&type=style&index=0&id=9af7d3e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports